import { InputGroup, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { Field } from 'react-final-form';

import useClientTranslations from '../../../../hooks/useClientTranslations';
import { TractableFormGroup } from './Shared';

const required = (field: string, t: any) => (value: any) => value ? undefined : t(`{{field}} is required`, { field });

const ClientClaimId: React.FC = () => {
	const { t } = useClientTranslations();

	return (
		<Field name="clientClaimId" validate={required(t('Claim ID'), t)}>
			{({ input, meta }) => (
				<TractableFormGroup
					label={t('Claim ID')}
					inline
					intent={Intent.DANGER}
					helperText={
						meta.invalid && meta.touched && (t(meta.error) || (!meta.dirtySinceLastSubmit && t(meta.submitError)))
					}
				>
					<InputGroup {...input} placeholder={t('ClaimExample')} />
				</TractableFormGroup>
			)}
		</Field>
	);
};

export { ClientClaimId };
